<template>
    <v-app  id="inspire">
        <v-content  id="landing-page" >
            <v-container fluid fill-height >
                <v-layout align-center justify-center >
                    <v-flex xs8 sm5 md4 lg3 xl2>
                        <div >
                            <div class="text-center" >
                                <img  src="@/assets/images/logo_completa.svg"  >
                                <!-- <img  src="@/assets/images/logo_branca.svg"  >
                                <img  src="@/assets/images/docbit.svg"  > -->
                            </div>
                            <div class="text-center" >
                                <p class="text-body-1">Recuperar Senha</p>
                            </div>
                            <br>
                            <v-alert v-if="message!=''" text  close-icon="mdi-delete" dismissible :color="color"  >
                                {{ message }}
                            </v-alert>
                        </div>
                        <ValidationObserver ref="observer" v-slot="{ passes }">
                            <div>
                                <v-form  >
                                    <ValidationProvider rules="required|email" v-slot="{ errors }" name='Email'>
                                        <v-text-field
                                                name="Login"
                                                :error-messages="errors"
                                                label="Seu E-mail"
                                                v-model.trim="email"
                                                autofocus
                                                dense
                                                solo prepend-inner-icon="mdi-email"
                                                @keyup.enter="sendMail"
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-form>
                            </div>
                            <br>

                            <div class="text-center" >
                                <v-btn outlined  to="/" class="mr-xs-1 mr-sm-10" color="primary">Voltar</v-btn>
                                <v-btn   @click="passes(sendMail)" color="primary">Recuperar</v-btn>
                            </div>
                        </ValidationObserver>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>

    </v-app>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import AuthService from '@/services/auth-service'
    export default {
        name: "ForgotPassword",
        components: {
            ValidationObserver,
            ValidationProvider
        },
        data () {
            return {
                email: '',
                message: '',
                color: 'red',
                active1: true
            }
        },
        methods: {
            sendMail () {
                AuthService.forgotPassword({input: {
                        email: this.email
                    }}).then((data) => {
                    this.active1 = true
                    this.message = data
                    this.color = 'red'
                    this.email = ''
                    if (data === 'Enviamos seu link de redefinição de senha por e-mail!') {
                        this.color = 'green'
                    }
                    if(data === 'Aguarde antes de tentar novamente.'){
                        this.color = 'red'
                    }
                })
            }
        },
        mounted() {
            let elHtml = document.getElementsByTagName('html')[0]
            elHtml.style.overflowY = 'auto'
        },
        destroyed() {
            let elHtml = document.getElementsByTagName('html')[0]
            elHtml.style.overflowY = null
        }
    }
</script>

<style scoped>
    #landing-page {
        background-image: url('../../assets/images/DOCBIT.png');
        height: 100vh;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }
    img {
        width: 100%;
    }

    @media only screen and (max-width: 700px) {
        .v-btn{
            margin-top:3px;
            margin-left: 2px;
        }
    }


</style>